"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownContainer = _interopRequireDefault(require("./DropdownContainer"));

var _InternalLink = _interopRequireDefault(require("../Navigation/InternalLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const DropdownOptions = _ref => {
  let {
    pages,
    clickCallback
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_DropdownContainer.default, null, pages.map(_ref2 => {
    let {
      title,
      path,
      groupTitle,
      group
    } = _ref2;

    if (title) {
      return /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
        onClick: () => clickCallback(),
        to: path,
        key: path
      }, title);
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: groupTitle
    }, /*#__PURE__*/_react.default.createElement("span", null, groupTitle), group.map(_ref3 => {
      let {
        path: itemPath,
        title: itemTitle
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
        onClick: () => clickCallback(),
        to: itemPath,
        key: itemPath
      }, itemTitle);
    }));
  }));
};

DropdownOptions.propTypes = {
  pages: _propTypes.default.arrayOf(_propTypes.default.object),
  clickCallback: _propTypes.default.func
};
DropdownOptions.defaultProps = {
  pages: [],
  clickCallback: null
};
var _default = DropdownOptions;
exports.default = _default;